import { Error } from "@mui/icons-material";
import {
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from "@mui/material";
import useCustomSearchParam from "../../hooks/useCustomSearchParam";
import useGetSpecies from "../../hooks/useGetSpecies";
import { useTranslation } from "react-i18next";

export default function SpeciesFilter({ param = "species", testId }) {
  const {t} = useTranslation();
  const { searchFn, searchParams } = useCustomSearchParam(param);
  const { translatedSpecies, isLoading, error } = useGetSpecies();

  function handleFilterChange(_, value) {
    searchFn(value);
  }

  if (isLoading) return <LinearProgress sx={{ width: "100%" }} />;
  if (error && !isLoading) return <Error color="error" />;

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{t("Species")}</InputLabel>
      <Select
        value={searchParams.get(param)}
        label={t("Species")}
        onChange={(e) => handleFilterChange(param, e.target.value)}
        SelectDisplayProps={{ ...(testId && { "data-testid": testId }) }}
      >
        <MenuItem value={null}>{t("Reset")}</MenuItem>
        {translatedSpecies?.map(({ id, title }) => (
          <MenuItem key={id} value={id}>
            {title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
